import React from 'react'
import useStore from '../store'


const PostcodeResult = ({placeName, postcode, stateCode, long, lat}) => {
  // const postcodeUser = useStore((state) => state.postcodeUser);
  const setPostcodeUser = useStore((state) => state.setPostcodeUser);
  const setPostcodeResults = useStore((state) => state.setPostcodeResults);
  const setSuburbUser = useStore((state) => state.setSuburbUser); 
  const setPostcodeUserLong = useStore((state) => state.setPostcodeUserLong);
  const setPostcodeUserLat = useStore((state) => state.setPostcodeUserLat);

  const postcodeSelected = useStore((state) => state.postcodeSelected);
  const setPostcodeSelected = useStore((state) => state.setPostcodeSelected);

  const setStateCode = useStore((state) => state.setStateCode);


  const handlePostcodeClick = () => {
    setPostcodeUser(postcode);
    setSuburbUser(placeName);
    setPostcodeUserLong(long);
    setPostcodeUserLat(lat);
    setPostcodeResults([]);
    setPostcodeSelected(true);
    setStateCode(stateCode);
  }

  return (
    <button className='flex space-x-2 hover:bg-gray-300 p-2' onClick={() => handlePostcodeClick()}>
        <p>{placeName}</p>
        <p>{postcode}</p>
        <p>{postcodeSelected}</p>
    </button>
  )
}

export default PostcodeResult